<div class="grid grid-cols-1 gap-3 md:grid-cols-3">
  @for (card of cards(); track card.labelKey) {
    @let value = card.value | rfiMetricValue;
    <app-metric-tile
      [label]="card.labelKey | transloco"
      [value]="value"
      [emptyText]="'project.steps.providerResults.individual.notSpecified' | transloco"
      [dimWhenEmpty]="true"
    >
      <span class="text-muted-color text-xs">
        @if (value === null) {
          {{ 'project.steps.providerResults.individual.notCalculable' | transloco }}
        } @else {
          {{ card.sourceKey | transloco }}
        }
        · SCA {{ card.scaNumbers.join(', ') }}
      </span>
    </app-metric-tile>
  }
</div>
